import {
  Collapse,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Tooltip,
  Typography,
} from "@mui/material";
import { RouteType } from "../../Routes/Routesconfig";
import {
  MasterDataContextType,
  useMasterData,
} from "../../ContextAPI/MasterContext";
import { useCallback, useEffect, useState } from "react";
import ExpandLessOutlinedIcon from "@mui/icons-material/ExpandLessOutlined";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import SidebarItem from "./SidebarItem";
import SVG from "../../Assests/SVG";
import { useTranslation } from "react-i18next";

const SidebarCollapse = ({
  item,
  isFirstParent = false,
}: {
  item: RouteType;
  isFirstParent?: boolean;
}) => {
  const { masterState } = useMasterData();
  const [open, setOpen] = useState(true);
  const { t } = useTranslation();

  // useEffect(() => {
  //   if (isFirstParent) {
  //     setOpen(true);
  //   } else {
  //     setOpen(false);
  //   }
  // }, [isFirstParent]);

  return item.sidebarProps ? (
    <>
      <ListItemButton
        onClick={() => setOpen(!open)}
        sx={{
          "&: hover": {
            backgroundColor: "#3D5476",
          },
          paddingY: "2px",
        }}
      >
        <Tooltip title={t(item?.sidebarProps?.displayText ?? "")}>
          <ListItemIcon
            sx={{
              color: "#fff",
              margin: `-5px`,
            }}
          >
            {item.sidebarProps.icon && item.sidebarProps.icon}
          </ListItemIcon>
        </Tooltip>
        <ListItemText
          sx={{ marginLeft: "-25px" }}
          disableTypography
          primary={
            <Typography variant="subtitle2" style={{ color: "#FFFFFF" }}>
              {t(item?.sidebarProps?.displayText ?? "")}
            </Typography>
          }
        />
        {open ? <SVG.SideDropArrow /> : <SVG.SideDownArrow />}
      </ListItemButton>
      <Collapse in={open} timeout="auto">
        <List>
          {item.child?.map((route, index) =>
            route.sidebarProps ? (
              route.child ? (
                <SidebarCollapse
                  item={route}
                  key={index}
                  isFirstParent={false}
                />
              ) : (
                <SidebarItem item={route} key={index} />
              )
            ) : null
          )}
        </List>
      </Collapse>
    </>
  ) : null;
};

export default SidebarCollapse;
